export class RouteUtils {
  private static readonly SALT = 'fc2026';

  /**
   * Retorna o ID normal (sem criptografia) para uso nas rotas
   */
  static encryptId(id: string | number): string {
    if (!id) return '';
    return String(id);
  }

  /**
   * Retorna o ID normal vindo da rota.
   * Suporta compatibilidade caso receba um ID legado que tenha sido ofuscado anteriormente.
   */
  static decryptId(encryptedId: string): string {
    if (!encryptedId) return '';
    try {
      // Se já for um ID simples (numérico ou UUID padrão sem base64 invertido), retorna direto
      if (/^\d+$/.test(encryptedId)) {
        return encryptedId;
      }

      // Tenta decodificar caso seja um ID legado com salt e base64
      let reversed = encryptedId.split('').reverse().join('');
      while (reversed.length % 4 !== 0) {
        reversed += '=';
      }

      const decoded = atob(reversed);
      const parts = decoded.split('-');
      if (
        parts.length >= 3 &&
        parts[0] === this.SALT &&
        parts[parts.length - 1] === this.SALT
      ) {
        parts.shift();
        parts.pop();
        return parts.join('-');
      }
      return encryptedId;
    } catch {
      return encryptedId;
    }
  }

  /**
   * Cria um slug a partir de um nome (ex: "Minha Campanha" -> "minha-campanha")
   */
  static slugify(text: string): string {
    if (!text) return 'detalhe';
    return text
      .toString()
      .normalize('NFD') // Normaliza acentos
      .replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') // Substitui espaços por hífens
      .replace(/[^\w-]+/g, '') // Remove caracteres não alfanuméricos
      .replace(/--+/g, '-'); // Remove múltiplos hífens
  }
}
